import { NAVIGATE_CLAIMS, NAVIGATE_EMERGENCY, NAVIGATE_HOME, NAVIGATE_OTHER, NAVIGATE_FNOL, NAVIGATE_PERSONAL_INSURANCE, NAVIGATE_LIFE_INSURANCE, NAVIGATE_PERSONAL_DETAILS, NAVIGATE_REQUEST_DOCUMENTS, NAVIGATE_DONATE_MY_DECREASE, NAVIGATE_REFER_A_FRIEND, NAVIGATE_MY_QUOTE, NAVIGATE_CONTACT_US, NAVIGATE_FNOL_SUBMIT_CLAIM, NAVIGATE_CLAIM_HISTORY_V2 } from "../constants/constants";

const initialState = {
    destination: "NAVIGATE_HOME",
    homeLine: "menu-active-border",
    claimsLine: "",
    menuSelected: {
        personalInsurance: false,
        lifeInsurance: false,
        personalDetails: false,
        requestDocuments: false,
        claimsProgress: false,
        submitClaim: false,
        claimsHistoryV2: false,
        donateMyDecrease: false,
        referAFriend: false,
        myQuote: false,
        contactUs: false,
        styleTemplate: false,
        handleSignOut: false,
        homePage: false
    },
    emergencyAssistLine: ""
}

const navigationReducer = (state = initialState, action) => {
    
    let destination = "";
    if (action.type === NAVIGATE_HOME || action.type === NAVIGATE_CLAIMS || action.type === NAVIGATE_EMERGENCY || action.type === NAVIGATE_OTHER || action.type === NAVIGATE_FNOL || action.type === NAVIGATE_FNOL_SUBMIT_CLAIM || action.type === NAVIGATE_CLAIM_HISTORY_V2 || action.type === NAVIGATE_PERSONAL_INSURANCE || action.type === NAVIGATE_LIFE_INSURANCE || action.type === NAVIGATE_PERSONAL_DETAILS || action.type === NAVIGATE_REQUEST_DOCUMENTS || action.type === NAVIGATE_DONATE_MY_DECREASE || action.type === NAVIGATE_REFER_A_FRIEND || action.type === NAVIGATE_CONTACT_US || action.type === NAVIGATE_MY_QUOTE) {
        destination = action.type;
    }
    let menuSelect = {
        personalInsurance: false,
        lifeInsurance: false,
        personalDetails: false,
        requestDocuments: false,
        claimsProgress: false,
        submitClaim: false,
        claimsHistoryV2: false,
        donateMyDecrease: false,
        referAFriend: false,
        myQuote: false,
        contactUs: false,
        styleTemplate: false,
        handleSignOut: false,
        homePage: false
    };

    switch (destination) {

        case NAVIGATE_HOME:
            menuSelect.homePage = true;
            return {
                ...state,
                destination: "NAVIGATE_HOME",
                homeLine: "menu-active-border",
                claimsLine: "",
                emergencyAssistLine: "",
                menuSelected: menuSelect
            };
        case NAVIGATE_CLAIMS:
            menuSelect.claimsProgress = true;
            return {
                ...state,
                homeLine: "",
                claimsLine: "menu-active-border",
                emergencyAssistLine: "",
                menuSelected: menuSelect
            }
        case NAVIGATE_EMERGENCY:
            return {
                ...state,
                destination: "NAVIGATE_EMERGENCY",
                homeLine: "",
                claimsLine: "",
                emergencyAssistLine: "menu-active-border",
                menuSelected: menuSelect
            }
        case NAVIGATE_FNOL:
            menuSelect.claimsProgress = true;
            return {
                ...state,
                destination: "NAVIGATE_CLAIMS",
                homeLine: "",
                claimsLine: "menu-active-border",
                emergencyAssistLine: "",
                menuSelected: menuSelect
            }

        case NAVIGATE_FNOL_SUBMIT_CLAIM:
            menuSelect.submitClaim = true;
            return {
                ...state,
                destination: "NAVIGATE_CLAIMS",
                homeLine: "",
                claimsLine: "menu-active-border",
                emergencyAssistLine: "",
                menuSelected: menuSelect
            }

        case NAVIGATE_CLAIM_HISTORY_V2:
            menuSelect.claimsHistoryV2 = true;
            return {
                ...state,
                destination: "NAVIGATE_CLAIMS",
                homeLine: "",
                claimsLine: "menu-active-border",
                emergencyAssistLine: "",
                menuSelected: menuSelect
            }
        case NAVIGATE_PERSONAL_INSURANCE:
            menuSelect.personalInsurance = true;
            return {
                ...state,
                homeLine: "",
                claimsLine: "",
                emergencyAssistLine: "",
                menuSelected: menuSelect
            }

        case NAVIGATE_LIFE_INSURANCE:
            menuSelect.lifeInsurance = true;
            return {
                ...state,
                homeLine: "",
                claimsLine: "",
                emergencyAssistLine: "",
                menuSelected: menuSelect
            }

        case NAVIGATE_PERSONAL_DETAILS:
            menuSelect.personalDetails = true;
            return {
                ...state,
                homeLine: "",
                claimsLine: "",
                emergencyAssistLine: "",
                menuSelected: menuSelect
            }

        case NAVIGATE_REQUEST_DOCUMENTS:
            menuSelect.requestDocuments = true;
            return {
                ...state,
                homeLine: "",
                claimsLine: "",
                emergencyAssistLine: "",
                menuSelected: menuSelect
            }

        case NAVIGATE_DONATE_MY_DECREASE:
            menuSelect.donateMyDecrease = true;
            return {
                ...state,
                homeLine: "",
                claimsLine: "",
                emergencyAssistLine: "",
                menuSelected: menuSelect
            }

        case NAVIGATE_REFER_A_FRIEND:
            menuSelect.referAFriend = true;
            return {
                ...state,
                homeLine: "",
                claimsLine: "",
                emergencyAssistLine: "",
                menuSelected: menuSelect
            }

        case NAVIGATE_MY_QUOTE:
            menuSelect.myQuote = true;
            return {
                ...state,
                homeLine: "",
                claimsLine: "",
                emergencyAssistLine: "",
                menuSelected: menuSelect
            }

        case NAVIGATE_CONTACT_US:
            menuSelect.contactUs = true;
            return {
                ...state,
                homeLine: "",
                claimsLine: "",
                emergencyAssistLine: "",
                menuSelected: menuSelect
            }

        case NAVIGATE_OTHER:
            return {
                ...state,
                destination: "NAVIGATE_OTHER",
                homeLine: "",
                claimsLine: "",
                emergencyAssistLine: "",
                menuSelected: menuSelect
            };
        
        default:
            return state
    }
}

export default navigationReducer;